export default "__VITE_ASSET__CvoWM3QH__"